import React from 'react';
import { useMsal } from '@azure/msal-react';

const UserProfile = () => {
  const { accounts, instance } = useMsal();

  const handleLogout = () => {
    // Clear local session and force component re-render
    try {
      // Method 1: Try clearCache first (clears tokens but keeps accounts)
      instance.clearCache();
      
      // Method 2: If that doesn't work, manually remove accounts
      const allAccounts = instance.getAllAccounts();
      allAccounts.forEach(account => {
        instance.removeAccount(account);
      });
      
      // Force a page refresh to ensure clean state
      window.location.reload();
    } catch (error) {
      console.log('Logout error:', error);
      // Fallback: force page refresh
      window.location.reload();
    }
  };

  if (accounts.length === 0) {
    return null;
  }

  const account = accounts[0];

  return (
    <div className="bg-white shadow rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-indigo-500 rounded-full flex items-center justify-center text-white font-semibold">
            {account.name ? account.name.charAt(0).toUpperCase() : 'U'}
          </div>
          <div>
            <p className="text-sm font-medium text-gray-900">{account.name}</p>
            <p className="text-xs text-gray-500">{account.username}</p>
          </div>
        </div>
        
        <button
          onClick={handleLogout}
          className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <svg className="-ml-0.5 mr-2 h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
          </svg>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default UserProfile;